/**
 * Exécute un tableau de fonctions asynchrones (promises) de manière séquentielle,
 * c'est-à-dire une à la fois, dans l'ordre du tableau.
 *
 * Contrairement à Promise.all, cette fonction attend que chaque promesse soit résolue
 * avant de passer à la suivante. Utile si les appels doivent être faits dans un ordre précis
 * ou si l'exécution parallèle pose des problèmes (API rate limiting, dépendances, etc.).
 *
 * @param promises - Un tableau de fonctions retournant des promesses
 * @returns Une promesse qui résout avec un tableau des résultats dans l'ordre d'exécution
 */
export default function promiseAllSequential<T>(promises: (() => Promise<T>)[]): Promise<T[]> {
	return promises.reduce((acc, fn) => {
		return acc.then(async results => {
			const res = await fn();
			return [...results, res];
		});
	}, Promise.resolve([] as T[]));
}